module.exports = __webpack_public_path__ + "static/in-the-shadow-of-statues-93d08d548dcec1f463f0f3177e8d211b.jpg";